
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"179","height":"361","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".4"}},[_c('path',{attrs:{"d":"M173.936 231.135l.378 3.62.405-3.62 3.62-.406-3.62-.378-.405-3.647-.378 3.647-3.647.378 3.647.406z","fill":"#fff"}}),_c('path',{attrs:{"d":"M116.017 91.984l.216 1.81.189-1.81 1.81-.216-1.81-.19-.189-1.81-.216 1.81-1.81.19 1.81.216z","fill":"#fff","opacity":".44"}}),_c('path',{attrs:{"d":"M123.636 29.014l.405 3.511.378-3.511 3.512-.379-3.512-.378-.378-3.539-.405 3.54-3.512.377 3.512.378z","fill":"#fff"}}),_c('path',{attrs:{"d":"M23.035 297.347l.405 3.62.405-3.62 3.62-.405-3.62-.379-.405-3.647-.405 3.647-3.62.379 3.62.405z","fill":"#fff","opacity":".28"}}),_c('path',{attrs:{"d":"M19.199 331.007l.216 1.999.216-1.999 1.999-.217-1.999-.216-.216-1.972-.216 1.972-2 .216 2 .217zM10.094 81.53l.216 1.998.217-1.999 1.972-.216-1.972-.216-.217-1.972-.216 1.972-1.999.216 2 .216zM117.935 352.618l.918 8.293.892-8.293 8.293-.891-8.293-.919-.892-8.293-.918 8.293-8.293.919 8.293.891zM82.466 125.59l.459 4.133.432-4.133 4.133-.46-4.133-.432-.432-4.133-.46 4.133-4.133.432 4.134.46z","fill":"#fff"}})])])
          )
        }
      }
    